import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.318.5H5.682A5.682 5.682 0 0 0 0 6.182v13.636A5.682 5.682 0 0 0 5.682 25.5h13.636A5.682 5.682 0 0 0 25 19.818V6.182A5.682 5.682 0 0 0 19.318.5ZM5.682 2.773h13.636a3.409 3.409 0 0 1 3.409 3.409v8.625l-2.943-2.943a3.409 3.409 0 0 0-4.83 0L12.818 14l-4.4-4.409a3.409 3.409 0 0 0-4.83 0l-1.315 1.318V6.182a3.409 3.409 0 0 1 3.409-3.409ZM2.273 19.818v-5.682l2.927-2.92a1.136 1.136 0 0 1 1.6 0l12.052 12.011H5.682a3.41 3.41 0 0 1-3.409-3.409Zm19.091 2.716L14.432 15.6l2.136-2.136a1.136 1.136 0 0 1 1.6 0l4.545 4.545v1.807a3.409 3.409 0 0 1-1.352 2.716l.003.002Z",
      fill: "#E6ACAA"
    }, null, -1)
  ]))]))
}
export default { render: render }